import script from "./method.vue?vue&type=script&setup=true&lang=ts"
export * from "./method.vue?vue&type=script&setup=true&lang=ts"

import "./method.vue?vue&type=style&index=0&id=20938e4c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20938e4c"]])

export default __exports__